module.exports = __webpack_public_path__ + "img/Assam Tourism National Photography Exhibition.806e62b7.jpg";